import { generate } from '@/utils/request';
const config = {
  prefix: '/third-adapter/v1/{organizationId}',
  items: [
    // 三方平台商品列表
    { key: 'getThirdPartyGoods', url: '/third-party-goodss', method: 'GET' },
    // 取消三方单 POST /v1/{organizationId}/third-order/cancel-order
    { key: 'cancelThirdPartyGoods', url: '/third-order/cancel-order', method: 'POST' },
    // 网店商品价格管理  新增
    { key: 'addThirdPartyGoods', url: '/third-party-goodss/save', method: 'POST' },
    // 网店商品价格管理  编辑
    { key: 'putThirdPartyGoods', url: '/third-party-goodss', method: 'PUT' },
    // 网店商品价格管理  sku校验
    { key: 'verifyThirdPartyGoodsSku', url: '/third-party-goodss/verifySku', method: 'POST' },

    // 根据条件调用pdd商品列表接口拉取数据
    { key: 'pullGoodsList', url: '/pdd-goods/pull-goods-list', method: 'POST' },
    // 三方平台商品内部商品-手动勾选内部sku列表
    {
      key: 'ThirdPartyGoodsMatchingInnerGoods',
      url: '/third-party-goodss/matching-inner-goods',
      method: 'POST',
    },
    // 根据拼多多商品ID下载
    {
      key: 'downloadThirdPartyGoodsById',
      url: '/pdd-goods/download-goods_by_id',
      method: 'POST',
    },
    // 三方平台商品内部商品-系统匹配
    {
      key: 'ThirdPartyGoodsMatchingInnerGoodsAuto',
      url: '/third-party-goodss/matching-inner-goods-auto',
      method: 'POST',
    },
    // 拼多多商品批量上下架
    {
      key: 'setPddGoodsStatus',
      url: '/pdd-goods/batch-goods-status',
      method: 'POST',
    },
    // 从文件导入临时表(异步)
    {
      key: 'ThirdImport',
      url: '/import/data/data-upload',
      method: 'POST',
      type: 'form',
    },

    /** 三方订单/按单号下载 */
    {
      key: 'downLoadOutToThird',
      url: '/third-order/out-to-third',
      method: 'POST',
    },
    /** 三方订单/按时间下载 */
    {
      key: 'downLoadOutToThirdOrderByTime',
      url: '/third-order/out-to-third-by-time',
      method: 'POST',
    },
    /** 正向单/异常单转正 */
    {
      key: 'thirdOrderToNormal',
      url: '/third-order/order-to-normal',
      method: 'POST',
      type: 'form',
    },

    // 删除三方平台商品
    { key: 'deleteThirdPartyGoods', url: '/third-party-goodss', method: 'DELETE' },
    /** 三方售后单列表 */
    {
      key: 'getThirdOrderAfterPage',
      url: '/third-party-after-sale-headers/order-page',
      method: 'POST',
    },
    // 三方售后单删除
    {
      key: 'deleteAfterOrder',
      url: '/third-party-after-sale-headers/delete?outRefundNo={outRefundNo}',
      method: 'GET',
    },
    /** 三方售后单确认导出 */
    {
      key: 'thirdOrderExport',
      url: '/third-party-after-sale-headers/export',
      method: 'POST',
    },
    /** 三方售后单外部售后单导入 历史日志 */
    {
      key: 'getThirdOrderAfterGetImportLog',
      url: '/third-party-after-sale-headers/getImportLog',
      method: 'POST',
    },
    /** 三方售后单详情 */
    {
      key: 'getThirdOrderAfterDetails',
      url: '/third-party-after-sale-headers/order-base-detail-by-id-code',
      method: 'POST',
    },
    /** 三方售后单/逆向单拉单（按单号） */
    {
      key: 'getOutToAfterThird',
      url: '/third-party-after-sale-headers/out-to-after-third',
      method: 'POST',
    },
    /** 三方售后单/逆向单拉单（按时间段） */
    {
      key: 'getAfterThirdByTime',
      url: '/third-party-after-sale-headers/after-by-time',
      method: 'POST',
    },
    /** 逆向单/异常单转正 */
    {
      key: 'thirdAfterOrderToNormal',
      url: '/third-party-after-sale-headers/refund-to-normal',
      method: 'POST',
      type: 'form',
    },
    /** 三方平台商品/同步库存 */
    {
      key: 'thirdPartyGoodsSyncStock',
      url: '/third-party-goodss/sync-stock',
      method: 'POST',
    },
    /** 三方平台商品/同步库存 */
    {
      key: 'getStockSyncLogs',
      url: '/stock-sync-logs',
      method: 'GET',
    },

    /**   ************  外部店铺映射管理  ***************  */
    /** 外部店铺映射表列表 */
    {
      key: 'getThirdShopMappingsList',
      url: '/third-shop-mappings',
      method: 'GET',
    },
    /** 创建外部店铺映射表 */
    {
      key: 'addThirdShopMappings',
      url: '/third-shop-mappings',
      method: 'POST',
    },
    /** 修改外部店铺映射表 */
    {
      key: 'putThirdShopMappings',
      url: '/third-shop-mappings',
      method: 'PUT',
    },
    /** 删除外部店铺映射表 */
    {
      key: 'deleteThirdShopMappings',
      url: '/third-shop-mappings',
      method: 'DELETE',
    },
    /** 外部店铺映射表明细 */
    {
      key: 'getThirdShopMappingsDetail',
      url: '/third-shop-mappings/{id}',
      method: 'GET',
    },

    // 普通内部商品上传三方
    {
      key: 'uploadSkuToThirdPartyOrdinary',
      url: '/third-party-goodss/upload-inner-common-goods',
      method: 'POST',
    },
    // 组合套餐内部商品上传三方
    {
      key: 'uploadSkuToThirdPartyPackage',
      url: '/third-party-goodss/upload-inner-combine-goods',
      method: 'POST',
    },
    // 根据外部订单号获取收货加密信息
    {
      key: 'getThirdPartyOrderEncryptReceiverInfo',
      url: '/third-party-orders/encrypt-receiver-info',
      method: 'GET',
    },

    /* ********************* 物流授权 *************************** */
    // 物流的三方电子面单授权配置列表
    {
      key: 'getLogisticsAuthorizes',
      url: '/logistics-authorizes',
      method: 'GET',
    },
    // 创建物流的三方电子面单授权配置
    {
      key: 'addLogisticsAuthorizes',
      url: '/logistics-authorizes',
      method: 'POST',
    },
    // 修改物流的三方电子面单授权配置
    {
      key: 'putLogisticsAuthorizes',
      url: '/logistics-authorizes',
      method: 'PUT',
    },
    // 删除物流的三方电子面单授权配置
    {
      key: 'deleteLogisticsAuthorizes',
      url: '/logistics-authorizes',
      method: 'DELETE',
    },
    // 物流的三方电子面单授权配置明细
    {
      key: 'getLogisticsAuthorizesDetail',
      url: '/logistics-authorizes/{id}',
      method: 'GET',
    },
    // 获取自定义模板
    {
      key: 'getLogisticsAuthorizesCustomares',
      url: '/logistics-authorizes/customares',
      method: 'GET',
      loadingHide: true,
    },
    // 获取标准模板
    {
      key: 'getLogisticsAuthorizesStdTemplate',
      url: '/logistics-authorizes/std-template',
      method: 'GET',
      loadingHide: true,
    },
    // 获取接口信息
    {
      key: 'getLogisticsAuthorizesinterfaceInfo',
      url: '/logistics-authorizes/interface-info',
      method: 'GET',
    },

    // 操作日志
    { key: 'getLogPage', url: '/operate-logs', method: 'GET' },

    // 获取邮编list
    {
      key: 'getPostCodePageList',
      url: '/address/getAddressPageList',
      method: 'POST'
    },

    // 更新邮编
    {
      key: 'updatePostCode',
      url: '/address/updateAddress',
      method: 'PUT'
    },

    // 新增邮编
    {
      key: 'addPostCode',
      url: '/address/saveAddress',
      method: 'POST'
    },

    // 删除邮编
    {
      key: 'deletePostCode',
      url: '/address/deleteByIds',
      method: 'DELETE'
    },

    // EXCEL批量导入邮编
    {
      key: 'bulkImportPostCode',
      url: '/address/saveBatchAddress',
      method: 'POST'
    },

    // EXCEL 导入单校验 ==》 马嘉琪
    // POST /v1/{organizationId}/third-order/pre-validate
    {
      key: 'checkImportFile',
      url: '/third-order/pre-validate',
      method: 'POST'
    },

    // 订单物流询价 ==》 马光浩
    // POST /v1/{organizationId}/third-order/order-rate
    {
      key: 'getOutOrderLogisticsInfo',
      url: '/third-order/order-rate',
      method: 'POST',
      loadingHide: true,
    },
    {
      key: 'csgOrderImport',
      url: '/third-order/csg-order-import?exportType=COLUMN',
      method: 'POST'
    },

    // 物流下单 根据外部单号获取订单详情 ==》 get /v1/{organizationId}/third-order/webDetail
    {
      key: 'webDetail',
      url: '/third-order/webDetail',
      method: 'POST'
    },
    // 运费计算器 批量取消 ==》 post /v1/{organizationId}/details/cancel
    {
      key: 'bulkCancelStatus',
      url: '/details/cancel',
      method: 'POST'
    },
    // Dashoard-Tips-Admin  post /v1/{organizationId}/dashboard/tips
    { key: 'getDashoardAdminData', url: '/dashboard/tips', method: 'POST', loadingHide: true, },
    // Dashoard-Tips-User  post /v1/{organizationId}/dashboard/tips-customer
    { key: 'getDashoardUserData', url: '/dashboard/tips-customer', method: 'POST', loadingHide: true, },

    // 库存预警 列表         get /v1/{organizationId}/stock-monitor/page
    { key: 'getStorkMonitorList', url: '/stock-monitor/page', method: 'GET', },
    // 库存预警 新增         post /v1/{organizationId}/stock-monitor
    { key: 'addStorkMonitorList', url: '/stock-monitor', method: 'POST', },
    // 库存预警 修改         put /v1/{organizationId}/stock-monitor/{id}
    { key: 'editStorkMonitorList', url: '/stock-monitor/{id}', method: 'PUT', },
    // 库存预警 删除         delete /v1/{organizationId}/stock-monitor/{id}
    { key: 'delStorkMonitorList', url: '/stock-monitor/{id}', method: 'DELETE', },
    // 库存预警 全部触发启动按钮  post /v1/{organizationId}/stock-monitor/ticket
    { key: 'goStorkMonitorAllButton', url: '/stock-monitor/ticket', method: 'POST', },
    // 库存预警 触发启动按钮  post /v1/{organizationId}/stock-monitor/ticket/{id}
    { key: 'goStorkMonitorButton', url: '/stock-monitor/ticket/{id}', method: 'POST', },

    // 订单 买家及收件信息（建议地址）   post /v1/{organizationId}/third-order/orderAddressVerification  马光浩
    { key: 'orderAddressVerification', url: '/third-order/orderAddressVerification', method: 'POST', },
  ],
};
export default {
  ...generate(config),
};
